module.exports = __webpack_public_path__ + "static/media/water.c4463be8.jpg";